import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const Menu = (props) => (
    <nav id="menu">
        <div className="inner">
            <ul className="links">
                <li><Link onClick={props.onToggleMenu} to="/">Home</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/#who">Who is Ardevia?</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/#what">What we do?</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/#contact">Contact</Link></li>
                {/*<li><Link onClick={props.onToggleMenu} to="/generic">Generic</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/elements">Elements</Link></li>*/}
            </ul>
            <ul className="actions vertical">
                <li><a href="/#contact" className="button special fit" onClick={props.onToggleMenu} >Get In Touch</a></li>
                {/*<li><a href="#" className="button fit">Log In</a></li>*/}
            </ul>
        </div>
        <a className="close" onClick={props.onToggleMenu} href="javascript:;">Close</a>
    </nav>
)

Menu.propTypes = {
    onToggleMenu: PropTypes.func
}

export default Menu
